import { Component, computed, inject, input, OnDestroy } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { UpperCasePipe } from '@angular/common';
import { Seo } from '../../core/seo';
import { breadcrumbLd, productLd } from '../../core/structured-data';
import { findEquipment } from '../../data/equipment';
import { Reveal } from '../../shared/reveal';

@Component({
  selector: 'app-equipment-detail',
  imports: [RouterLink, UpperCasePipe, Reveal],
  templateUrl: './equipment-detail.html',
  styleUrl: './equipment.scss'
})
export class EquipmentDetail implements OnDestroy {
  /** Bound from the route via withComponentInputBinding-style routing params. */
  readonly slug = input('');

  private readonly seo = inject(Seo);
  private readonly router = inject(Router);

  /**
   * The slug is resolved against a fixed allow-list, so an unknown or hostile
   * value can never reach the template — there is no injection surface here.
   */
  readonly item = computed(() => {
    const found = findEquipment(this.slug().toLowerCase());
    if (!found) {
      void this.router.navigate(['/404'], { skipLocationChange: true });
      return undefined;
    }
    this.seo.apply({
      title: `${found.name} | Mechtron Water Services`,
      description: found.summary,
      path: `/equipment/${found.slug}`,
      image: found.image,
      type: 'product'
    });
    this.seo.setJsonLd('ld-product', productLd(found));
    this.seo.setJsonLd('ld-breadcrumb', breadcrumbLd([
      { name: 'Home', path: '/' },
      { name: 'Equipment', path: '/equipment' },
      { name: found.name, path: `/equipment/${found.slug}` }
    ]));
    return found;
  });

  ngOnDestroy(): void {
    this.seo.clearJsonLd('ld-product');
    this.seo.clearJsonLd('ld-breadcrumb');
  }
}
